import IntegratorIntegrations from '@/sections/vendors/integrations/summary/integrations-summary-page';
import VendorIntegrationHistory from '@/sections/vendors/integrations/history/vendor-integration-history.vue';

export default [
	{
		path: '/vendors/:integratorId(\\d+)/integrations',
		component: IntegratorIntegrations,
		props: route => ({
			integratorId: parseInt(route.params.integratorId),
			search: route.query.search,
			sortby: route.query.sortby || 'name',
			sortdirection: route.query.sortdirection || 'asc',
			status: route.query.status || 'all',
			page: parseInt(route.query.page) || 1,
			count: parseInt(route.query.count) || 100
		}),
		meta: {
			permissions: ['vendors.read']
		}
	},

	{
		name: 'vendors-integration-settings',
		path: '/vendors/:integratorId(\\d+)/integrations/:id(\\d+)',
		props: route => ({
			id: parseInt(route.params.id),
			integratorId: parseInt(route.params.integratorId),
			integratorName: route.params.integratorName
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/sections/vendors/integrations/settings/vendors-integration-settings-page.vue'
			),
		meta: {
			permissions: ['vendors.update']
		}
	},
	{
		path: '/vendors/:vendorid(\\d+)/integrations/add/securevue',
		name: 'vendors-integrations-add-securevue',
		props: route => ({
			integratorId: parseInt(route.params.vendorid),
			integratorName: route.params.integratorName
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/sections/vendors/integrations/add/securevue/integration-securevue-summary-page.vue'
			),
		meta: {
			permissions: ['vendors.create']
		}
	},
	{
		name: 'vendors-integrations-history',
		path: '/vendors/:vendorId/integrations/history/:integrationId',
		props: route => ({
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			search: route.query.search || '',
			minDatetime: route.query.minDatetime,
			maxDatetime: route.query.maxDatetime,
			changedByUserId: route.query.changedByUserId,
			vendorId: route.params.vendorId,
			integrationId: route.params.integrationId,
			page: parseInt(route.query.page) || 1,
			countPerPage: parseInt(route.query.countPerPage) || 10
		}),
		component: VendorIntegrationHistory,
		meta: {
			permissions: ['vendors.read']
		}
	}
];
